
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["play_svg__icon",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 1024 1024","xmlns":"http://www.w3.org/2000/svg","width":"200","height":"200"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M893.035 463.822c-54.027-34.123-682.45-435.063-713.73-454.967-39.81-25.592-79.619 8.53-79.619 48.34v909.934c0 45.497 42.653 68.245 76.776 48.34 45.496-28.435 676.763-429.375 716.573-454.967 34.123-22.748 34.123-76.776 0-96.68z","fill":"#666"}})])
          )
        }
      }
    